import { Table } from 'antd';
import AntTable from './index.style';

const StyledTable = AntTable(Table);

export default StyledTable;
